<i class="fs-16px form-control-status error" ui-icon uiType="caution"></i>
